module.exports = "<mat-error *ngIf=\"!control || error?.message\">\r\n    {{ error?.message }}\r\n</mat-error>"